"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDelBitValue = exports.hasBitValue = exports.getSetBitValue = void 0;
/**
 * @example
 * getSetBitValue(0b00000001, 0b1) => 0b00000001; (no change)
 * getSetBitValue(0b00000010, 0b1) => 0b00000011; (changed)
 */
const getSetBitValue = (src, value) => src | value;
exports.getSetBitValue = getSetBitValue;
/**
 * @example
 * hasBitValue(0b00000001, 0b1) => true;
 * hasBitValue(0b00000010, 0b1) => false;
 */
const hasBitValue = (src, value) => (src & value) !== 0;
exports.hasBitValue = hasBitValue;
/**
 * @example
 * getDelBitValue(0b00000001, 0b1) => 0b00000000; (changed)
 * getDelBitValue(0b00000010, 0b1) => 0b00000010; (no change)
 */
const getDelBitValue = (src, value) => src & ~value;
exports.getDelBitValue = getDelBitValue;
//# sourceMappingURL=Bit.js.map